// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RqIp-","tabsBox":"styles_tabsBox__2nNiK","createButton":"styles_createButton__2T4pu"};